/// <amd-module name="Wit/Filter/ParentFilterProvider" />
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { FieldFilterProvider } from "Wit/Filter/FieldFilterProvider";
import { IBoardFilterDataSource, IFilterProvider } from "Wit/Filter/FilterManager";
import { UnparentedFilterItem } from "./FilterValueProviders";

export class ParentFilterProvider extends FieldFilterProvider implements IFilterProvider {
    /**
     * Mapping of work item id to all ancestors
     */
    protected _childToParentsMap = new Map<number, number[]>();
    protected _dataProvider: IBoardFilterDataSource;

    constructor() {
        super(CoreFieldRefNames.Parent);
    }

    public bind(dataProvider: IBoardFilterDataSource) {
        this._dataProvider = dataProvider;
    }

    public dataUpdated() {
        this._childToParentsMap.clear();
    }

    public getMatchingItems(items: number[]): number[] {
        if (items === null) {
            // Null items means process all work items.
            items = this._dataProvider.getIds();
        }

        const matchingIds: number[] = [];

        for (const item of items) {
            if (this.matchesFilter(item)) {
                matchingIds.push(item);
            }
        }

        return matchingIds;
    }

    protected matchesWhenFilterByTree(value: number): boolean {
        // Get all ancestors of the supplied item
        let parentIds = this._childToParentsMap.get(value);
        if (!parentIds) {
            this._childToParentsMap.set(value, this._dataProvider.getAllParents(value));
            parentIds = this._childToParentsMap.get(value);
        }

        // include the selected parent when filtering by tree
        return this.matchesParentFilter(value) || parentIds.some(id => this.matchesParentFilter(id));
    }

    protected matchesFilter(value: number): boolean {
        if (this._filter.options?.filterByTree) {
            return this.matchesWhenFilterByTree(value);
        } else {
            const parentId = this._dataProvider.getValue(value, this._fieldName);
            const parentValue = parentId ?? UnparentedFilterItem.key;
            return this.matchesParentFilter(parentValue);
        }
    }

    protected matchesParentFilter(value: number | string): boolean {
        return String(value) in this._filterValueMap;
    }
}
